module.exports = __webpack_public_path__ + "static/media/DairyNZ.e46797e2.jpg";